import { combineReducers } from 'redux'
import { createReducer } from 'helpers/ReducerUtil'
import {
  UPDATE_SELECTED_FASTTRACK_PROJECT
} from './constants'
import * as R from 'ramda'

import comments from 'containers/Project/GreenlightCommentSection/reducer'

import {
  currentRevision,
  projects,
  revisions,
  active,
  actionType
} from 'containers/Project/GreenlightReport/reducer'

const updateSelectedFastTrackProject = (prev, { projectId }) => projectId
const selectedFastTrackProject = createReducer(null, {
  [UPDATE_SELECTED_FASTTRACK_PROJECT] : updateSelectedFastTrackProject
})

export default combineReducers({
  comments,
  revisions,
  projects,
  currentRevision,
  active,
  actionType,
  selectedFastTrackProject
})
